export default "__VITE_ASSET__oFjPPQY2__"